import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from '@app/app.module';
import { AppInjectorService } from '@app/core/services/app-injector.service';
import { registerWithGlobalApp } from '@app/utils/app';
import { Logger, loggerFor } from '@app/utils/logger';
import { environment } from './environments/environment';

setDefaults();

const logger = loggerFor('main');

if (environment.production) {
  enableProdMode();
  // Raise stacktrace limit to ensure application code is contained
  Error.stackTraceLimit = 20;
}

const bootstrap = function () {
  return platformBrowser()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
      AppInjectorService.injector = moduleRef.injector;

      return moduleRef;
    });
};

handleBranding();

console.time('Bootstrapping');
bootstrap().catch((err) => logger.error(err));

function handleBranding() {
  const applicationStylesTagSelector = 'link[href^="/portal/assets-custom"][rel="stylesheet"]';
  const stylesTagSelector = 'link[href^="styles"][rel="stylesheet"]';

  if (environment.withBranding) {
    logger.debug('Move branding...');

    // Move the branding css after the angular style css
    const link = document.querySelector(applicationStylesTagSelector);
    // const styleTag = document.querySelector('style')
    const styleTag = document.querySelector(stylesTagSelector);
    logger.debug('queried applicationStylesTag element', link);
    logger.debug('queried styleTag element', styleTag);

    if (styleTag !== null) {
      document.getElementsByTagName('head')[0].insertBefore(styleTag, link);

      if (environment.production === false) {
        // add livereload
        const script = document.createElement('script');
        script.src = `http://${(location.host || 'localhost').split(':')[0]}:35729/livereload.js?snipver=1`;
        document.head.appendChild(script);
      }
    }
  } else if (environment.production === false) {
    logger.debug('Remove branding...');
    document.querySelector(applicationStylesTagSelector)?.remove();
  }
}

/**
 * Sets various defaults across the application (everything that is included here is angular-independent)
 */
function setDefaults() {
  // Make the logger available for outside usage (e.g. to set the logging level manually whilst running)
  registerWithGlobalApp('log', Logger);
  Logger.setDefaultLevel(environment.logLevel);

  const DataTable = $.fn.dataTable;

  $.extend(DataTable.ext.classes, {
    sWrapper: 'dataTables_wrapper dt-bootstrap4',
  });
}
